// -*- Mode: rjsx -*-
import React from 'react';

import Typography from '@mui/material/Typography';
import Skeleton from 'react-loading-skeleton';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';

import { Flag } from "../../flag";

import { FancyDate, FHTheme, FHMaterialStyles } from '../../../ui';

function Header(props) {
    const request = props.request;    
    const classes = FHMaterialStyles();
    const textColor = FHTheme.palette.text.secondary;
    
    return(
        <Grid className={classes.adminRequestHeaderContainer} direction="row" container>
          <Grid item xs={10} >
		    <h1 style={{ marginBottom: 0 }}> { request.title || <Skeleton width={500} /> }</h1>
            <Grid container direction="row"  spacing={1} style={{fontSize: "80%", color: textColor }}>
              {/* <Grid item> */}
              {/*   { request.user.key ? <UserLink user={request.user} /> : <Skeleton width={150} /> } */}
              {/* </Grid> */}
              <Grid item>
		        <FancyDate date={request.date_created} icon={true} label="Created"/>
              </Grid>
              <Grid item>
                  <FancyDate date={request.date_updated} icon={true} label="Updated" /> 
              </Grid>              
            </Grid>
          </Grid>
          <Grid item xs={2}>
            <Flag request={request} />
          </Grid>
        </Grid>        
    );
}

export default Header;
